import { useContext, useState } from "react";
import { TotalEntradaUtils } from "../../utils/TotalEntradaUtils";
import { ValidarMembresia } from "../../utils/ValidarMembresia";
import { ValidarEntrada } from "../../utils/ValidarEntrada";
import { ValidarStock } from "../../utils/ValidarStock";

const ComprarEntradas = ({
  setStep,
  step,
  entradas,
  onClick,
  comission,
  form,
  evento,
  fechas,
  label,
  image,
  me,
  loading,
}) => {
  return (
    <div
      className="modal fade"
      id="exampleModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog mx-auto" style={{ minWidth: "100%" }}>
        <div className="modal-content" style={{ borderRadius: "30px" }}>
          <div className="modal-header border-0">
            <h5 className="modal-title" id="exampleModalLabel"></h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-md-5">
                <div
                  className="overflow-hidden"
                  style={{
                    position: "relative",
                    width: "100%",
                    paddingTop: "100%",
                  }}
                >
                  <img
                    src={image}
                    alt=""
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
              </div>
              <div className="col-md-7">
                <div>
                  <nav>
                    <div
                      className="nav nav-tabs d-flex justify-content-center align-items-center border-0 py-3"
                      id="nav-tab"
                      role="tablist"
                    >
                      <button
                        className={
                          step == 0
                            ? "bg-transparent fw-bold text-custom-naranja border-0 d-flex items-align-center "
                            : "bg-transparent fw-bold text-dark border-0 d-flex items-align-center "
                        }
                        onClick={() => setStep(0)}
                        id="nav-cantidad-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#nav-cantidad"
                        type="button"
                        role="tab"
                        aria-controls="nav-cantidad"
                        aria-selected="false"
                      >
                        <i
                          className={
                            step == 0
                              ? "bi bi-2-circle-fill text-custom-naranja fw-bold titulo-size me-2"
                              : "bi bi-2-circle-fill text-dark fw-bold titulo-size me-2"
                          }
                        ></i>
                        <span className="titulo-size Grifter">
                          Elegir entrada
                        </span>
                      </button>
                      <div
                        className="d-none d-md-block"
                        style={{
                          borderBottom: "1px solid black",
                          width: "60px",
                          height: "1px",
                        }}
                      ></div>
                      <button
                        className={
                          step == 1
                            ? "bg-transparent fw-bold text-custom-naranja border-0 d-flex items-align-center me-3"
                            : "bg-transparent fw-bold text-dark border-0 d-flex items-align-center me-3"
                        }
                        onClick={() => setStep(1)}
                        id="nav-pagar-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#nav-pagar"
                        type="button"
                        role="tab"
                        aria-controls="nav-contact"
                        aria-selected="false"
                      >
                        <i
                          className={
                            step == 1
                              ? "bi bi-3-circle-fill text-custom-naranja fw-bold titulo-size me-2"
                              : "bi bi-3-circle-fill text-dark fw-bold titulo-size me-2"
                          }
                        ></i>
                        <span className="titulo-size Grifter">Pagar</span>
                      </button>
                    </div>
                  </nav>
                  <div className="tab-content" id="nav-tabContent">
                    <div
                      className="tab-pane fade py-5  show active"
                      id="nav-cantidad"
                      role="tabpanel"
                      aria-labelledby="nav-cantidad-tab"
                      tabindex="0"
                    >
                      {entradas.map((entrada, index) => {
                        return (
                          <div
                            className={`${
                              ValidarEntrada(entrada) ? "" : "d-none"
                            }`}
                          >
                            <div
                              className="text-center  d-md-flex d-block justify-content-between"
                              style={{
                                opacity: entrada.quantity ? 1 : 0.5,
                              }}
                            >
                              <div className="fw-bold fs-6 text-start text-dark d-block">
                                <div>{entrada.nombre}</div>
                              </div>
                              <span className="fw-bold fs-5 text-dark">
                                $
                                {entrada.pricexquantity
                                  ? parseFloat(
                                      entrada.pricexquantity
                                    ).toLocaleString("es-AR", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })
                                  : parseFloat(entrada.precio).toLocaleString(
                                      "es-AR",
                                      {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      }
                                    )}
                              </span>
                              <div>
                                <div className=" d-flex justify-content-center">
                                  <button
                                    className="btn py-2 px-4 fw-bold fs-6 border border-dark"
                                    style={{
                                      borderRadius: "20px 0px 0px 20px",
                                    }}
                                    name="remove"
                                    onClick={(event) =>
                                      onClick(event, {
                                        ...entrada,
                                        index: index,
                                      })
                                    }
                                  >
                                    -
                                  </button>
                                  <input
                                    className="form-controll py-1 text-center fs-6 GothamBold"
                                    type="number"
                                    value={entrada.quantity ?? 0}
                                    style={{ width: "100px" }}
                                  />
                                  <button
                                    className="border-dark btn py-1 px-4 fw-bold fs-6 border"
                                    style={{
                                      borderRadius: "0px 20px 20px 0px",
                                    }}
                                    name="add"
                                    onClick={(event) => {
                                      if (entrada.remain !== 0) {
                                        onClick(event, {
                                          ...entrada,
                                          index: index,
                                        });
                                      }
                                    }}
                                  >
                                    +
                                  </button>
                                </div>

                                <span
                                  className={`${
                                    ValidarStock(entrada, form, evento.reportes)
                                      ? "d-none"
                                      : ""
                                  }`}
                                  style={{ fontSize: "10px" }}
                                >
                                  <span className={`ms-1`}>
                                    Entradas agotadas
                                  </span>
                                </span>

                                <span
                                  className={`${
                                    ValidarStock(entrada, form, evento.reportes)
                                      ? ""
                                      : "d-none"
                                  }`}
                                  style={{ fontSize: "10px" }}
                                >
                                  {"+Serv ARS " +
                                    parseFloat(entrada.serv ?? 0).toLocaleString(
                                      "es-AR",
                                      {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      }
                                    ) ?? 0}
                                  <span
                                      className={`ms-1  ${
                                        entrada.remain <= 20 ? "" : "d-none"
                                      }`}
                                    >
                                      Quedan {entrada.remain ?? 0} entradas!
                                    </span>
                                </span>
                              </div>
                            </div>

                            <hr></hr>
                          </div>
                        );
                      })}

                      <div className="row">
                        <div className="col-md-6 mb-2">
                          <span className="d-block fw-bold">
                            {evento?.nombre}
                          </span>
                          <span className="d-block">
                            {evento?.nombre_sitio}
                          </span>
                          <span className="d-block">{`${form.fecha} Hora: ${form.hora}`}</span>
                        </div>
                        <div className="col-md-6">
                          <div className="w-100 d-flex justify-content-between">
                            <div className="fs-6 fw-bold">SubTotal</div>
                            <div className="fs-6 fw-bold">
                              {"ARS " +
                                parseFloat(
                                  TotalEntradaUtils(evento.entradas, comission)
                                    .subTotal
                                ).toLocaleString("es-AR", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                            </div>
                          </div>
                          <div className="w-100 d-flex justify-content-between">
                            <div className="fs-6 fw-bold">
                              +Serv {comission}%
                            </div>
                            <div className="fs-6 fw-bold">
                              {"ARS " +
                                parseFloat(
                                  TotalEntradaUtils(evento.entradas, comission)
                                    .serv
                                ).toLocaleString("es-AR", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                            </div>
                          </div>
                          <div className="w-100 d-flex justify-content-between">
                            <div className="fs-6 fw-bold">Total</div>
                            <div className="fs-6 fw-bold">
                              {"ARS " +
                                parseFloat(
                                  TotalEntradaUtils(evento.entradas, comission)
                                    .total
                                ).toLocaleString("es-AR", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="tab-pane fade"
                      id="nav-pagar"
                      role="tabpanel"
                      aria-labelledby="nav-pagar-tab"
                      tabindex="0"
                    >
                      <ul className="list-group">
                        <li className="px-3 py-3 rounded-0 list-group-item p-0 m-0 mb-1 border-start-0 border-end-0">
                          <span className="d-block fw-bold">
                            {evento?.nombre}
                          </span>
                          <span className="d-block">
                            {evento?.nombre_sitio}
                          </span>
                          {`${form.fecha} Hora: ${form.hora}`}
                        </li>

                        <li className="px-3 py-3 rounded-0 list-group-item p-0 m-0 border-start-0 border-end-0 ">
                          <span className="GothamBold d-block">Entradas</span>
                          {evento?.entradas.map((entrada, index) => {
                            if (entrada.quantity > 0) {
                              return (
                                <div
                                  className="d-flex justify-content-between"
                                  key={index}
                                >
                                  <span className="GothamBold fs-6">
                                    {`${entrada.nombre} x${entrada.quantity}`}
                                  </span>
                                  <span className="GothamBold fs-6">{`ARS ${parseFloat(
                                    entrada.pricexquantity
                                  ).toLocaleString("es-AR", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}`}</span>
                                </div>
                              );
                            }
                          })}
                        </li>

                        <li className="px-3 py-3 rounded-0 list-group-item p-0 m-0 border-start-0 border-end-0 ">
                          <div className="d-flex justify-content-between">
                            <span className="GothamBold fs-6">SubTotal</span>
                            <span className="GothamBold fs-6">
                              {" "}
                              {"ARS " +
                                parseFloat(
                                  TotalEntradaUtils(evento.entradas, comission)
                                    .subTotal
                                ).toLocaleString("es-AR", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                            </span>
                          </div>
                        </li>

                        <li className="px-3 py-3 rounded-0 list-group-item p-0 m-0 border-start-0 border-end-0 ">
                          <div className="d-flex justify-content-between">
                            <span className="GothamBold fs-6">
                              +Serv({comission}%)
                            </span>
                            <span className="GothamBold fs-6">
                              {" "}
                              {"ARS " +
                                parseFloat(
                                  TotalEntradaUtils(evento.entradas, comission)
                                    .serv
                                ).toLocaleString("es-AR", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                            </span>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="d-flex justify-content-center py-2">
                  <label
                    className={
                      step == 0
                        ? "d-none"
                        : "btn btn-outline-dark fw-normal py-4 fs-6 d-flex justify-content-center align-items-center  me-2"
                    }
                    style={{
                      width: "160px",
                      lineHeight: 1,
                      padding: "10px 10px 10px",
                      borderRadius: "10px",
                    }}
                  >
                    <i className="bi bi-chevron-left fs-6"></i>
                    Atras
                    <button
                      className="d-none"
                      onClick={(e) => {
                        let int = step - 1;
                        switch (int) {
                          case 0:
                            {
                              document
                                .getElementById("nav-cantidad-tab")
                                .click();
                            }
                            break;
                          default:
                            break;
                        }
                        setStep(int);
                      }}
                    ></button>
                  </label>

                  {label(step)}
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer border-0"></div>
        </div>
      </div>
    </div>
  );
};

export default ComprarEntradas;
